// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"9416d6f7","612":"ef7109a7","770":"d5a59d78"}[chunkId] + ".chunk.css";
};